module.exports = __webpack_public_path__ + "media/2.11eb8dd3.mp3";